import { Alert, AlertTitle, Box, Stack, Typography } from '@mui/material'
import { FormattedMessage } from 'react-intl'

import { useCreateFormatDate } from '@/hooks'

import { addDays, parse } from 'date-fns/esm'
import { getAlertConfig } from '../utils/getAlertConfig'

interface Props {
  config: ReturnType<typeof getAlertConfig>
  lastRecurrenceSuccess: string | undefined
}

export function StorageAlert(props: Props) {
  const { config, lastRecurrenceSuccess } = props
  const formatDate = useCreateFormatDate()

  if (!config) return null

  const { title, description, contentOne, contentTwoId, severity } = config

  const firstDayWithoutOccurrences = lastRecurrenceSuccess
    ? addDays(parse(lastRecurrenceSuccess, 'yyyyMMdd', new Date()), 1)
    : undefined

  return (
    <Alert severity={severity} data-testid="storage-alert">
      <AlertTitle>{title}</AlertTitle>

      <Stack spacing={1}>
        <Typography variant="body2">{description}</Typography>

        {(contentOne || contentTwoId) && (
          <Box component="ul" sx={{ paddingLeft: 3, margin: 0 }}>
            {contentOne && (
              <Typography component="li" variant="body2">
                {contentOne}
              </Typography>
            )}

            {contentTwoId && (
              <Typography component="li" variant="body2">
                <FormattedMessage
                  id={contentTwoId}
                  values={{
                    b: chunks => (
                      <Typography
                        component="span"
                        variant="body2"
                        fontWeight="bold"
                        display="inline"
                      >
                        {chunks}
                      </Typography>
                    ),
                    date: firstDayWithoutOccurrences
                      ? formatDate(firstDayWithoutOccurrences, true)
                      : '',
                  }}
                />
              </Typography>
            )}
          </Box>
        )}
      </Stack>
    </Alert>
  )
}
